module.exports = __webpack_public_path__ + "static/zalesie-corner-68ca3c4262d1dff6b6b32284649e1ca0.png";